<button class="lang" #anchor (click)="toggle()">
  {{ currentLang | uppercase }}
  <mat-icon class="arrow" svgIcon="icon_arrow"></mat-icon>
</button>
<button data-cy="header-actions-account_button" #anchorAccount (click)="toggleAccount()">
  <mat-icon svgIcon="icon_account" class="account"></mat-icon>
</button>
<button (click)="onHelp()">
  <mat-icon svgIcon="icon_help" class="help"></mat-icon>
</button>
@if (showAccount) {
  <kendo-popup
    #popupAccount
    [anchor]="anchorAccount"
    [anchorAlign]="anchorAlign"
    [popupAlign]="popupAlign"
    popupClass="content"
  >
    <app-account-menu></app-account-menu>
  </kendo-popup>
}

@if (show) {
  <kendo-popup #popup [anchor]="anchor" [anchorAlign]="anchorAlign" [popupAlign]="popupAlign" popupClass="content">
    <app-lang></app-lang>
  </kendo-popup>
}
